import styled from "styled-components";

const ButtonGroupWrapper = styled.div`
  overflow: hidden;
  display: inline-block;
  height: 20px;
  vertical-align: top;
  margin-left: -2px;
`;

export default ButtonGroupWrapper;
